import axios from 'axios';
import { v1 as uuid } from 'uuid';
import { parse } from 'query-string';
import { HOME_ROOT } from 'config/api';

const homeActions = {
  FETCH: 'HOME_FETCH',
  FETCH_SUCCESS: 'HOME_FETCH_SUCCESS',

  GET_PLAID: 'HOME_GET_PLAID',
  GET_PLAID_SUCCESS: 'HOME_GET_PLAID_SUCCESS',

  START: 'HOME_START',
  START_FAILED: 'HOME_START_FAILED',
  START_SUCCESS: 'HOME_START_SUCCESS',

  fetch: (id, endpoint) => ({
    payload: { endpoint, id, request: () => axios.get(`${HOME_ROOT}/${id}/${endpoint}`) },
    type: homeActions.FETCH,
  }),

  getPlaid: (id, cb) => ({
    payload: { cb, request: () => axios.get(`${HOME_ROOT}/${id}/getPlaidConfigs`) },
    type: homeActions.GET_PLAID,
  }),

  getStartRequest: (deviceToken) => {
    const searchParams = parse(window.location.search);
    let browserSessionToken = sessionStorage.getItem('browserSessionToken');

    if (!browserSessionToken) {
      const token = uuid();
      sessionStorage.setItem('browserSessionToken', token);
      browserSessionToken = token;
    }
    const source = searchParams.of_source || searchParams.utm_source || searchParams.ml_source;
    const medium = searchParams.of_medium || searchParams.utm_medium || searchParams.ml_medium;
    const term = searchParams.of_term || searchParams.utm_term || searchParams.ml_term;
    const content = searchParams.of_content || searchParams.utm_content || searchParams.ml_content;
    const campaign =
      searchParams.of_campaign || searchParams.utm_campaign || searchParams.ml_campaign;
    const {
      appRequestId,
      emailToken,
      existing,
      market,
      page,
      prefillToken,
      product,
      resendEmailToken,
      restart,
      t: token,
    } = searchParams;
    const searchParamsState = {
      appRequestId,
      browserSessionToken,
      campaign,
      content,
      deviceToken,
      emailToken,
      existing,
      market,
      medium,
      page,
      prefillToken,
      product,
      resendEmailToken,
      restart,
      source,
      term,
      token,
    };

    return {
      request: () => axios.post(`${HOME_ROOT}/start`, searchParamsState),
      searchParamsState,
    };
  },

  startSuccess: (data, searchParams = {}) => ({
    payload: { data, searchParams },
    type: homeActions.START_SUCCESS,
  }),
};

export default homeActions;
